import { ReactComponent as AmazonColorLight } from 'fym-shared/src/music-services/assets/images/amazon-color-light.svg';
import { ReactComponent as AmazonColorDark } from 'fym-shared/src/music-services/assets/images/amazon-color-dark.svg';
import { ReactComponent as AmazonColorLightPadding } from 'fym-shared/src/music-services/assets/images/amazon-color-light-padding.svg';
import { ReactComponent as AmazonColorDarkPadding } from 'fym-shared/src/music-services/assets/images/amazon-color-dark-padding.svg';
import { MusicServiceImages } from './types';

export const amazonMusicImages: MusicServiceImages = {
  logoColor: {
    light: AmazonColorLight,
    dark: AmazonColorDark,
  },
  logoColorPadding: {
    light: AmazonColorLightPadding,
    dark: AmazonColorDarkPadding,
  },
};
